import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    card1: {
      paddingBottom: '8px',
      background: 'none',
    },
    auditLogHeader: {
      fontSize: '16px',
      color: 'rgba(255,255,255,0.6)',
    },
    grid1: {
      display: 'inline-flex',
    },
    topGrid1: {
      paddingBottom: '16px',
    },
    topGrid: {
      height: '68px',
      background: 'rgba(255,255,255,0.05)',
      borderRadius: '8px',
    },
    iconGrid: {
      minHeight: '92px',
      background: 'rgba(255,255,255,0.05)',
      borderRadius: '8px',
    },
    nameGrid: {
      alignSelf: 'center',
      paddingLeft: '16px',
    },
    detailsGrid: {
      display: 'inline-flex',
    },
    descriptionGrid: {
      alignSelf: 'center',
      padding: '0px 10px 0px 10px',
    },
    none: {
      color: 'rgba(255,255,255,0.38)',
      paddingRight: '10px',
    },
    userIcon: {
      display: 'flex',
      paddingLeft: '10px',
      alignSelf: 'center',
      '& .MuiSvgIcon-root': {
        width: '40px',
        height: '40px',
      },
    },
    subtitle: {
      color: 'rgba(255,255,255,0.87)',
      paddingLeft: '10px',
    },
    timeStamp: {
      textAlign: 'right',
      paddingRight: '20px',
      paddingTop: '22px',
    },
    fileName: {
      letterSpacing: '0.5px',
      lineHeight: '24px',
    },
    ArrowForwardStyle: {
      marginRight: 10,
    },
    okButtonGrid: {
      padding: 5,
    },
    oldestGrid: {
      justifyContent: 'flex-end',
      display: 'flex',
      alignSelf: 'center',
      placeItems: 'center',
      '& .oldest': {
        paddingRight: '10px',
        fontSize: '14px',
        letterSpacing: '1.25px',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
      },
      '& .icon': {
        width: '20px',
        height: '20px',
        cursor: 'pointer',
      },
    },
    dividerGrid: {
      marginLeft: 16,
      marginRight: 16,
      alignSelf: 'center',
      height: 32,
      background: 'rgba(255,255,255,0.4)',
    },
    xFeatherGrid: {
      alignSelf: 'center',
      marginLeft: '10px',
      marginRight: '10px',
      display: 'flex',
    },
    searchBarOuterGrid: {
      paddingRight: '10px',
      display: 'flex',
      '& .searchBarBg': {
        backgroundColor: '#121212',
      },
    },
    searchBarOuterGrid1: {
      paddingLeft: '10px',
      display: 'flex',
    },
    offline: {
      top: '50%',
      position: 'absolute',
      margin: 0,
    },
    circular: {
      textAlign: 'center',
    },
  }),
);

export default useStyles;
